import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface SkillThresholds {
    '1_2': number; // Principiante → Básico
    '2_3': number; // Básico → Intermedio
    '3_4': number; // Intermedio → Avanzado
    '4_5': number; // Avanzado → Experto
}

export interface GrikyAdminSettings {
    grikySkillsLearnerAccess: boolean;
    skillThresholds: SkillThresholds;
    academicProfileModule: boolean;
}

@Injectable({ providedIn: 'root' })
export class GrikySkillsAdminApiService {
    private baseUrl: string;

    constructor(private http: HttpClient) {
        const apiUrl = environment.envVar.API_URL.endsWith('/')
            ? environment.envVar.API_URL.slice(0, -1)
            : environment.envVar.API_URL;
        this.baseUrl = `${apiUrl}/admin/companies`;
    }

    getSettings(companyId: number): Observable<GrikyAdminSettings> {
        return this.http.get<GrikyAdminSettings>(
            `${this.baseUrl}/${companyId}/griky-skills/settings`
        );
    }

    updateSettings(companyId: number, data: Partial<GrikyAdminSettings>): Observable<GrikyAdminSettings> {
        return this.http.put<GrikyAdminSettings>(
            `${this.baseUrl}/${companyId}/griky-skills/settings`,
            data
        );
    }
}
